import { combineReducers } from 'redux'
import approvedOrders from './approvedOrders'
import providerMetrics from './providerMetrics'

export default combineReducers({
  approvedOrders,
  providerMetrics,
})
